import { useEffect, useRef } from 'react';

function useInterval(time: number) {
  const intervalRef = useRef<ReturnType<typeof setInterval> | undefined>();
  const interval = (cb: () => void) => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        cb();
      }, time);
    }
  };
  const cancelInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = undefined;
  };
  useEffect(() => {
    return () => {
      cancelInterval();
    };
  }, []);

  return { interval, cancelInterval };
}

export default useInterval;
